import { LinkOutlined, PersonAddOutlined } from '@mui/icons-material';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';

interface MessageCardProps {
  msg: any;
  actionTooltip: string;
  actionColor: 'success' | 'warning';
  actionIcon: React.ReactNode;
  onAction: () => void;
  onAddClient?: (msg: any) => void;
  onAssignClient?: (msg: any) => void;
}

const MessageCard: React.FC<MessageCardProps> = ({ msg, actionTooltip, actionColor, actionIcon, onAction, onAddClient, onAssignClient }) => {
  const client = msg._client;
  const displayName = client
    ? [client.first_name, client.last_name].filter(Boolean).join(' ')
    : [msg.senderFirstName, msg.senderLastName].filter(Boolean).join(' ') || msg.senderName;
  const displayPhone = client
    ? client.contacts?.find((c: any) => c.type === 'phone')?.value
    : msg.senderPhone;

  return (
    <Box sx={{ border: 1, borderColor: client ? 'primary.main' : 'divider', borderRadius: 2, p: 2 }}>
      {client && (
        <Chip label="عميل محفوظ" size="small" color="primary" variant="outlined" sx={{ mb: 1 }} />
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Box>
          <Typography variant="caption" color="text.secondary">الاسم</Typography>
          <Typography variant="subtitle2" fontWeight={700}>{displayName}</Typography>
        </Box>
        {displayPhone && (
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="caption" color="text.secondary">الهاتف</Typography>
            <Typography variant="subtitle2" dir="ltr">{displayPhone}</Typography>
          </Box>
        )}
      </Box>
      {client?.contacts?.filter((c: any) => c.type === 'email').map((c: any, i: number) => (
        <Box key={i} sx={{ mb: 1 }}>
          <Typography variant="caption" color="text.secondary">البريد</Typography>
          <Typography variant="subtitle2" dir="ltr">{c.value}</Typography>
        </Box>
      ))}
      {msg.message && (
        <Box sx={{ mb: 1.5 }}>
          <Typography variant="caption" color="text.secondary">الرسالة</Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{msg.message}</Typography>
        </Box>
      )}
      {msg.submittedAt && (
        <Box>
          <Typography variant="caption" color="text.secondary">التاريخ</Typography>
          <Typography variant="caption" display="block">
            {new Date(msg.submittedAt?.seconds ? msg.submittedAt.seconds * 1000 : msg.submittedAt).toLocaleString('ar')}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5, mt: 1 }}>
        {!client && onAddClient && (
          <Tooltip title="إضافة كعميل جديد">
            <IconButton size="small" color="primary" onClick={() => onAddClient(msg)}>
              <PersonAddOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {onAssignClient && (
          <Tooltip title={client ? "تغيير العميل المرتبط" : "ربط بعميل موجود"}>
            <IconButton size="small" color="primary" onClick={() => onAssignClient(msg)}>
              <LinkOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title={actionTooltip}>
          <IconButton size="small" color={actionColor} onClick={onAction}>
            {actionIcon}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default MessageCard;
